import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Button} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import {CircularProgress} from "@material-ui/core";

const apiBaseUrl = process.env.REACT_APP_API_URL;

class ResetPassword extends Component {
    state = {
        email: '',
        password: '',
        resetId: '',
        loading: true
    };

    constructor(props) {
        super(props);
        globalProps = props;
    }

    componentDidMount() {
        this.loadReset();
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="login-background">
                    <MuiThemeProvider>
                        <img src={require('../../JXB Logo.png')} alt="JXB Performance" style={{width: 200, margin: '20px auto 0'}} />
                        <div className="container" style={{maxWidth: 400, marginTop: 20, padding: '25px 10px'}}>
                            <CircularProgress />
                            <br/>&#9400; {new Date().getFullYear()} JXB Performance, All rights reserved.
                        </div>
                    </MuiThemeProvider>
                </div>
            );
        }
        
        return (
            <div className="login-background">
                <MuiThemeProvider>
                    <img src={require('../../JXB Logo.png')} alt="JXB Performance" style={{width: 200, margin: '20px auto 0'}} />
                    <div className="container" style={{maxWidth: 400, marginTop: 20, padding: '25px 10px'}}>
                        <div>
                            <TextField
                                type="password"
                                placeholder="Enter a new password"
                                label="New Password"
                                variant="outlined"
                                autoComplete="off"
                                onChange={(event) => this.setState({password: event.target.value})}
                                onKeyPress={(event) => {
                                    this.handleEnter(event);
                                }}
                            />
                            <div ref="btnResetPassword" style={{display: 'block'}}>
                                <Button primary={true} style={style}
                                              className="success-button-lg"
                                              onClick={(event) => this.resetPassword(event)}>Set New Password</Button>
                            </div>
                            <div ref="divLoading" style={{display: 'none'}}>
                                <br/>
                                <CircularProgress />
                            </div>
                        </div>
                        <br />
                        <center>&#9400; {new Date().getFullYear()} JXB Performance, All rights reserved.</center>
                    </div>
                </MuiThemeProvider>
            </div>
        );
    }

    handleEnter(event) {
        if (event.key === 'Enter') {
            this.resetPassword(event);
            event.preventDefault();
        }
    }

    loadReset = () => {
        const self = this;
        const resetId = globalProps.match.params.resetId;
        if (resetId === undefined || resetId.length === 0) {
            globalProps.history.push('/password/forgot');
        }
        axios.get(`${apiBaseUrl}users/password_reset/${resetId}`).then((resetResponse) => {
            if (resetResponse.status === 200) {
                self.setState({resetId, user: resetResponse.data, loading: false});
            } else {
                globalProps.history.push('/password/forgot');
            }
        }).catch(() => {
            globalProps.history.push('/password/forgot');
        })
    };

    resetPassword = () => {
        const self = this;
        const {user} = this.state;
        const payload = {
            "email": user,
            "password": this.state.password
        };
        self.refs.btnResetPassword.style = "display: none;";
        self.refs.divLoading.style = "display: block;";
        if (user && user.length > 0 && this.state.password.length > 0) {
            axios.post(`${apiBaseUrl}users/password_reset/${this.state.resetId}`, payload).then(function (resetResponse) {
                if (resetResponse.status === 200) {
                    globalProps.history.push('/login');
                }
            })
                .catch(function (error) {
                    window.$alertWarning('Uh oh! Something went wrong.');
                    console.log(error);
                    self.refs.btnResetPassword.style = "display: block";
                    self.refs.divLoading.style = "display: none;";
                });
        } else {
            window.$alertWarning('Enter your new password and try again.');
            self.refs.btnResetPassword.style = "display: block";
            self.refs.divLoading.style = "display: none;";
        }
    };
}

let globalProps;

const style = {
    margin: 15,
};

export default ResetPassword;
